module.exports = __webpack_public_path__ + "static/Wish-e078c7ea0a6ecb0167a637d7f3b15ac4.jpg";